<template>
  <div class="accessories-container" :class="{ collapsed: collapsed }">

    <!-- modular package "included accessory" section heading -->
    <header v-if="isModularPackage()" class="note-header">
      <h5 v-if="getT">
        {{
          getT.static.customizer[0].options_container[0]
            .accessory_list[0].included_heading
        }}
      </h5>
      <div class="description">
        <button v-on:click="showLearnMore(getT.static.customizer[0].options_container[0]
            .accessory_list[0].included_learn_more)" v-if="getT">
          {{
            getT.static.customizer[0].options_container[0]
              .finishing_option_list[0].learn_more_button_text
          }}
        </button>
      </div>
    </header>
    
    <!-- included accessory list -->
    <ul class="option-list">
      <li v-for="key in $store.getters.includedAccessories" v-bind:key="key">
        <Accessory :accId="key" :acc="$store.state.accessories[key]" :isIncluded="true" />
      </li>
    </ul>

    <!-- modular package "add-on accessory" section heading -->
    <header v-if="isModularPackage()" class="note-header">
      <h5 v-if="getT">
        {{
          getT.static.customizer[0].options_container[0]
            .accessory_list[0].add_on_heading
        }}
      </h5>
      <div class="description">
        <button v-on:click="showLearnMore(getT.static.customizer[0].options_container[0]
            .accessory_list[0].add_on_learn_more)" v-if="getT">
          {{
            getT.static.customizer[0].options_container[0]
              .finishing_option_list[0].learn_more_button_text
          }}
        </button>
      </div>
    </header>

    <!-- swim spa "select accessory" section heading -->
    <header v-else class="note-header">
      <h5 v-if="getT">
        {{
          getT.static.customizer[0].options_container[0]
            .accessory_list[0].heading
        }}
      </h5>
      <div class="description">
        <p class="muted" v-if="getT">
          {{
            getT.static.customizer[0].options_container[0]
              .accessory_list[0].description
          }}
        </p>
      </div>
    </header>
    <ul class="option-list add-on">
      <li v-for="key in $store.getters.availableAccessories" v-bind:key="key">
        <Accessory :accId="key" :acc="$store.state.accessories[key]" :isIncluded="false" />
      </li>
    </ul>

  </div>
</template>
<script>
import Accessory from './../accessories/Accessory';
import { mapGetters } from 'vuex';
import { categoryOfPool } from '../../poolData';

export default {
  name: 'AccessoryList',
  props: ['collapsed'],
  data() {
    return {
      showPopup: false,
    };
  },
  components: {
    Accessory,
  },
  methods: {
    toSummary: function () {
      this.$router.push('/summary');
    },
    isModularPackage: function () {
      // The modular (AKA 'custom') category contains packages and the spa category does not.
      const cat = categoryOfPool(this.$store.state.model.tag);
      if (cat.tag === 'custom') {
        return true;
      }
      return false;
    },
    showLearnMore: function(text) {
      this.$store.commit('showInfoPopup', text);
    }
  },
  computed: {
    ...mapGetters(['getT']),
  },
};
</script>
<style scoped lang="scss">
.accessories-container {
  transition: opacity 400ms cubic-bezier(0.645, 0.045, 0.355, 1),
    height 400ms cubic-bezier(0.645, 0.045, 0.355, 1);
  &.collapsed {
    opacity: 0;
    height: 0;
  }
  ul.option-list {
    margin: 0;
    padding: 0;
    position: relative;
    z-index: 1;
    li {
      line-height: 0;
    }
    &.add-on {
      margin-bottom: 3em;
    }
  }
}
</style>
